import React, { useEffect } from "react";

import styled from "@emotion/styled";
import shallow from "zustand/shallow";

import ProductList from "./components/ProductList";
import SideNavigation from "./components/SideNavigation";
import useStore from "./store";

const Container = styled.div`
    position: relative;
    display: grid;
    gap: 50px;
    grid-template-columns: 1fr;

    ${({ theme }) => theme.breakpoints.from.medium.css`
    grid-template-columns: 1fr 3fr;
  `}
`;

const TechnicCatalog = () => {
    const [getData] = useStore((state) => [state.getData], shallow);

    useEffect(() => {
        getData();
    }, []);

    return (
        <Container>
            <SideNavigation />
            <ProductList />
        </Container>
    );
};

export default TechnicCatalog;
